import { CellTextContentData } from '../cell-variants/types.ts';

import { TableSectionsData } from './table.tsx';

export function getColumnCount(sections: TableSectionsData) {
	return getColumnCountOfRowsOfSections(sections);
}

function getColumnCountOfRowsOfSections(sections: TableSectionsData) {
	if (sections.length === 0) {
		throw new Error('sections count should be > 0');
	}

	let columnCount: number | undefined;

	sections.forEach((section, index) => {
		try {
			const columnCountOfRows = getColumnCountOfRows(section.rows);
			if (columnCount === undefined) {
				columnCount = columnCountOfRows;
			} else {
				if (columnCount !== columnCountOfRows) {
					throw new Error(
						`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`,
					);
				}
			}
		} catch (error) {
			throw new Error(`error at table section index ${index}`, {
				cause: error,
			});
		}
	});

	if (columnCount === undefined) {
		throw new Error('column count is undefined');
	}

	return columnCount;
}

function getColumnCountOfRows(rows: CellTextContentData[][]) {
	if (rows.length === 0) {
		throw new Error('rows count should be > 0');
	}

	let columnCount: number | undefined;
	rows.forEach((row, index) => {
		if (columnCount === undefined) {
			columnCount = row.length;
		} else {
			if (row.length !== columnCount) {
				throw new Error(
					`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`,
				);
			}
		}
	});

	if (columnCount === undefined) {
		throw new Error('column count is undefined');
	}

	if (columnCount === 0) {
		throw new Error('columnCount should not be 0');
	}

	return columnCount;
}
